export const GET_SUMMER_CAMPS_2026_FROM_CHILD = /* GraphQL */ `
  query getSummerCamps2026FromChild {
    me {
      id
      children {
        id
        name
        surname
        summer2026: availableProducts(
          category: "Lato"
          period: { start: "2026-01-01", end: "2026-12-31" }
        ) {
          ... on IProduct {
            sku
            name
            stock {
              available
            }
            price {
              value
            }
          }
        }
      }
    }
  }
`;

export const ADD_SUMMER_CAMPS_2026_TO_CART = /* GraphQL */ `
  mutation AddToCartSummerCamp($sku: ID!, $childId: ID!) {
    cartAddItem(sku: $sku, childId: $childId) {
      id
      problems {
        ... on ICartProblem {
          code
          message
        }
        ... on CartProblemCustomData {
          item {
            ... on ICartItem {
              id
              sku
            }
          }
          property
        }
      }
      items {
        ... on CartItemSummerCamp {
          sku
          id
        }
      }
    }
  }
`;
